import { createContext, useContext, useState, useEffect } from 'react';
import { updateUserProfile } from '../firebase/db';
import { useAuth } from './AuthContext';

const DemoContext = createContext(null);

export const useDemo = () => useContext(DemoContext);

export const DemoProvider = ({ children }) => {
  const { user, profile, refreshProfile, isAdmin } = useAuth();
  const [demoMode, setDemoModeState] = useState(() => {
    const saved = localStorage.getItem('fieldsync_demo_mode');
    return saved === 'true';
  });

  useEffect(() => {
    if (profile && profile.demoMode !== undefined && isAdmin) {
      setDemoModeState(profile.demoMode);
      localStorage.setItem('fieldsync_demo_mode', String(profile.demoMode));
    } else if (!isAdmin) {
      // Force demo mode OFF for non-admins
      setDemoModeState(false);
      localStorage.removeItem('fieldsync_demo_mode');
    }
  }, [profile, isAdmin]);

  const setDemoMode = async (value) => {
    if (!isAdmin) {
      console.warn('Demo mode toggle is admin-only');
      return;
    }
    setDemoModeState(value);
    localStorage.setItem('fieldsync_demo_mode', String(value));
    if (user) {
      await updateUserProfile(user.uid, { demoMode: value });
      await refreshProfile();
    }
  };

  const value = {
    demoMode,
    setDemoMode,
  };

  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>;
};
